export default __webpack_public_path__ + "static/media/vuesax-linear-teacher2.118b9f76.svg";